<footer>
    <div class="block lg:hidden">
        
        <p class="small flex flex-col text-center">
            <lib-button class="underline" [cssType]="'btn-link'"  [bold]="true" [buttonType]="'link'"  [text]="'Accessibility'" [size]="'small-link'" [externalLink]="true" [href]="'https://wholesaleinsurancehub.com/accessibility'"></lib-button>
            <lib-button class="underline" [cssType]="'btn-link'"  [bold]="true" [buttonType]="'link'"  [text]="'Privacy'" [size]="'small-link'" [externalLink]="true" [href]="'https://wholesaleinsurancehub.com/privacy-statement'"></lib-button>
            <lib-button class="underline" [cssType]="'btn-link'"  [bold]="true" [buttonType]="'link'"  [text]="'Terms'" [size]="'small-link'" [externalLink]="true" [href]="'https://wholesaleinsurancehub.com/terms-of-use'"></lib-button>
        </p>
        
        <p class="small pt-3">
            &copy; {{curentYear}} Wholesale Insurance Hub
        </p>
        <span class="px-2">|</span>
        <span>{{ this.environment.prettyVersion() }}</span>
        
    </div>

    <div class="hidden lg:flex">
        <p class="small">
            <span>&copy; {{curentYear}} <lib-button class="underline" [cssType]="'btn-link'"  [bold]="true" [buttonType]="'link'"  [text]="'Wholesale Insurance Hub'" [size]="'small-link'" [externalLink]="true" [href]="'https://wholesaleinsurancehub.com'"></lib-button></span>
            <span class="px-2">|</span>
            <span><lib-button class="underline" [cssType]="'btn-link'"  [bold]="true" [buttonType]="'link'"  [text]="'Accessibility'" [size]="'small-link'" [externalLink]="true" [href]="'https://wholesaleinsurancehub.com/accessibility'"></lib-button></span>
            <span class="px-2">|</span>
            <span> <lib-button class="underline" [cssType]="'btn-link'"  [bold]="true" [buttonType]="'link'"  [text]="'Privacy'" [size]="'small-link'" [externalLink]="true" [href]="'https://wholesaleinsurancehub.com/privacy-statement'"></lib-button></span>
            <span class="px-2">|</span>
            <span><lib-button class="underline" [cssType]="'btn-link'"  [bold]="true" [buttonType]="'link'"  [text]="'Terms'" [size]="'small-link'" [externalLink]="true" [href]="'https://wholesaleinsurancehub.com/terms-of-use'"></lib-button></span>
            <span class="px-2">|</span>
            <span>{{ this.environment.prettyVersion() }}</span>
        </p>
    </div>
</footer>
